import script from "./orderReceipt.vue?vue&type=script&lang=ts&setup=true"
export * from "./orderReceipt.vue?vue&type=script&lang=ts&setup=true"

import "./orderReceipt.vue?vue&type=style&index=0&id=df36fcf0&scoped=true&lang=css"

import exportComponent from "D:\\work\\CP_new_work\\saas-h5-project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-df36fcf0"]])

export default __exports__